export default __webpack_public_path__ + "static/gallery-img7-62cc59e0066135c058354f123c805897.jpg";